import { Button, Dialog, Portal, Text } from '@welbe/design-system';
import { tokens } from '@welbe/web-design-system';
import React from 'react';

type ModalSuccessProps = {
	open: boolean;
	onClose: () => void;
};

export const ModalSuccess = ({ open, onClose }: ModalSuccessProps) => {
	return (
		<Dialog.Root size="sm" open={open} onOpenChange={onClose}>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content>
						<Dialog.Header padding="2rem">
							<Dialog.Title
								width="100%"
								fontSize="1.125rem"
								fontWeight="600"
								color={tokens.color_primary}
								textAlign="center"
							>
								¡Archivo cargado correctamente!
							</Dialog.Title>
						</Dialog.Header>
						<Dialog.Body
							padding="1rem 2.5rem 1.5rem 2.5rem"
							gap="0.5rem"
							display="flex"
							flexDirection="column"
							fontWeight="500"
							color={tokens.color_gray_dark}
						>
							<Text>El archivo se cargó correctamente y será procesado.</Text>
							<Text>
								Esto puede demorar unos minutos, en cuanto finalice el
								procesamiento, te enviaremos un correo electrónico con el
								reporte de los colaboradores creados.
							</Text>
						</Dialog.Body>
						<Dialog.Footer
							width="100%"
							justifyContent="center"
							padding="1rem 2.5rem 2.5rem 2.5rem"
						>
							<Button size="sm" onClick={onClose} width="50%">
								Concluir
							</Button>
						</Dialog.Footer>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
